import { useEffect, useState, useCallback } from "react";
import apiRequest from "../services/apiRequest";

export const useWorksiteUsers = (worksite) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchWorksiteUsers = useCallback(async (additional_rperms=[]) => {
    setLoading(true);
    try {
      const response = await apiRequest.post(
        "/users/from_perm_list",
        {
          perm: worksite.r_perm.concat(additional_rperms),
          active: true
        }
      );
      const userData = response.map((u) => ({
        id: u.id,
        name: `${u.firstname} ${u.lastname}`,
        email: u.email,
        role: u.role.name,
        company: u.company,
        flg_internal: u.flg_internal, // aggiunto per vedere se è stato condiviso almeno ad un utente interno
      }));
      setUsers(userData);
      return userData;
    } finally {
      setLoading(false);
    }
  }, [worksite]);

  useEffect(() => {
    if (!worksite) {
      return;
    }

    fetchWorksiteUsers();
  }, [worksite, fetchWorksiteUsers]);

  return [users, setUsers, loading, fetchWorksiteUsers];
};
